type TableVariation = Pick<
  Variation,
  "color" | "gauge" | "length" | "weight"
>;

type VariationTableData = {
  gauges: string[];
  lengths: string[];
  table: string[][];
};

export const buildVariationTable = (
  variations: TableVariation[],
  selectedColor: string
): VariationTableData => {
  const scopedVariations = selectedColor
    ? variations.filter((variation) => variation.color === selectedColor)
    : variations;
  const gauges = scopedVariations
    .map((variation) => variation.gauge)
    .filter((gauge, index, values) => values.indexOf(gauge) === index)
    .sort();
  const lengths = scopedVariations
    .map((variation) => variation.length)
    .filter((length, index, values) => values.indexOf(length) === index)
    .sort();
  const table = gauges.map((gauge) => [
    gauge,
    ...lengths.map((length) => {
      const variation = scopedVariations.find(
        (item) => item.gauge === gauge && item.length === length
      );

      return variation?.weight || "X";
    }),
  ]);

  return { gauges, lengths, table };
};
